module.exports = __webpack_public_path__ + "media/33.06df3fd7.wav";